import * as requestFromServer from "./usersCrud";
import { v4 as uuid } from "uuid";
import { usersSlice, callTypes } from "./usersSlice";

const { actions } = usersSlice;

//request api for users and save in redux
export const fetchUsers = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return requestFromServer
    .findUsers(queryParams)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.usersFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const changePassword = (id,params,history) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  // console.log("🚀 ~ file: usersActions.js ~ line 23 ~ changePassword ~ params", params);
  // ;
  return requestFromServer
    .changePassword(id,params)
    .then((response) => {
      console.log("🚀 ~ file: usersActions.js ~ line 29 ~ .then ~ response", response);
      const { totalCount, entities, message } = response.data;
      dispatch(actions.changedPassword({ totalCount, entities, message }));
      history.push('/logout')
    })
    .catch((error) => {
      // 
      // console.log("🚀 ~ file: usersActions.js ~ line 34 ~ changePassword ~ error", error.message);
      // console.log("🚀 ~ file: usersActions.js ~ line 34 ~ changePassword ~ error", error.response.data.errors);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

//update message
export const updateMessage = (type, message) => (dispatch) => {
  dispatch(actions.updateMessage({ type, message }));
};
export const createUser = (user,cb) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createUser(user)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.userCreated({ message, entity }));
      cb&&cb()
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      cb&&cb()
    });
};

export const updateUser = (user) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateUser(user)
    .then((response) => {
      const { message, entity } = response.data;
      dispatch(actions.userUpdated({ message, entity }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const changeStatus = (id, status) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .changeStatus(id, status)
    .then((response) => {
      if (response.status == 200) {
        const { message, entity } = response.data;
        dispatch(actions.statusChanged({ message, entity }));
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// toggle chat/message access for a user
export const updateUserAccess = (id, payload) => (dispatch) => {
  console.log("🚀 ~ file: usersActions.js ~ line 88 ~ updateUserAccess ~ payload", payload,id);
  dispatch(actions.userAccessPatched({ id, payload }));
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .toggleUserAccess(id, payload)
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        const { message, entity } = response.data;
        dispatch(actions.userUpdated({ message, entity }));
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setStatusBack = (id, status) => (dispatch) => {
  dispatch(actions.setStatusBack({ id, status }));
};
export const changeCompleteStatus = (status) => (dispatch) => {
  dispatch(actions.changeCompleteStatus({ status }));
};

export const setRolePermissions = (roles) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  dispatch(actions.setRolePermissions(roles));
};
export const resetRolePermissions = () => (dispatch) => {
  dispatch(actions.resetRolePermissions());
};
